import(/* webpackMode: "eager" */ "/home/app/actions-runner/_work/pteultra-home/pteultra-home/app/global-error.tsx");
